import React from "react";
import { Sparkles, BookHeart, Printer } from "lucide-react";
import cover from "@/assets/cover.jpeg";
import { Reveal, HotmartButton, ReassuranceRow, Stars } from "./common";
import { PRICE, SITE } from "@/lib/site";

const chips = [
  { icon: BookHeart, label: "Lectura + color" },
  { icon: Sparkles, label: "2 a 6 años" },
  { icon: Printer, label: "Imprime en casa" },
];

export const Hero = () => {
  return (
    <section
      id="inicio"
      className="relative overflow-hidden bg-[radial-gradient(1200px_circle_at_15%_0%,rgba(168,216,240,0.4),transparent_55%),radial-gradient(900px_circle_at_90%_5%,rgba(253,230,138,0.4),transparent_55%),linear-gradient(to_bottom,#FFF8EE,rgba(255,248,238,0.5))]"
    >
      <div className="mx-auto w-full max-w-6xl px-4 py-12 sm:px-6 sm:py-16 lg:py-20">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-12 lg:gap-8">
          {/* Copy */}
          <div className="lg:col-span-7">
            <Reveal>
              <span className="inline-flex items-center gap-2 rounded-full border border-[hsl(var(--border))] bg-white/70 px-3 py-1 text-xs font-bold text-[hsl(var(--brand-ink))] backdrop-blur">
                <Stars /> Un tesoro para colorear en familia
              </span>
            </Reveal>
            <Reveal delay={0.05}>
              <h1 className="mt-4 font-heading text-4xl font-extrabold leading-[1.05] tracking-tight text-[hsl(var(--brand-ink))] sm:text-5xl lg:text-6xl">
                Colorea las promesas de Dios{" "}
                <span className="text-[hsl(var(--brand-coral))]">junto a tu hijo</span>
              </h1>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-5 max-w-xl text-base leading-relaxed text-muted-foreground sm:text-lg">
                Una herramienta hermosa y <strong className="text-[hsl(var(--brand-ink))]">libre de frustraciones</strong> para pasar
                tiempo de calidad, desarrollar su creatividad y sembrar la fe de forma
                sencilla y divertida. Ideal para niños de <strong className="text-[hsl(var(--brand-ink))]">{SITE.ageRange}</strong>.
              </p>
            </Reveal>

            <Reveal delay={0.15}>
              <ul className="mt-6 flex flex-wrap gap-2.5">
                {chips.map((c) => (
                  <li
                    key={c.label}
                    className="inline-flex items-center gap-2 rounded-full bg-white px-3.5 py-2 text-sm font-semibold text-[hsl(var(--brand-ink))] shadow-[0_6px_16px_rgba(31,41,55,0.06)]"
                  >
                    <c.icon className="h-4 w-4 text-[hsl(var(--brand-coral))]" />
                    {c.label}
                  </li>
                ))}
              </ul>
            </Reveal>

            <Reveal delay={0.2}>
              <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
                <HotmartButton testId="hero-primary-cta-button">
                  Quiero el ebook por ${PRICE.offer} MXN
                </HotmartButton>
                <a
                  href="#oferta"
                  data-testid="hero-secondary-cta-button"
                  className="inline-flex h-14 items-center justify-center rounded-xl border border-[hsl(var(--border))] bg-white px-6 text-base font-bold text-[hsl(var(--brand-ink))] transition-colors duration-200 hover:bg-[hsl(var(--brand-sky))]/25"
                >
                  Ver qué incluye
                </a>
              </div>
            </Reveal>
            <Reveal delay={0.25}>
              <ReassuranceRow className="mt-5" />
            </Reveal>
          </div>

          {/* Mockup */}
          <div className="lg:col-span-5">
            <Reveal delay={0.15}>
              <div className="relative mx-auto w-[260px] sm:w-[320px] lg:w-[360px]">
                <div className="pointer-events-none absolute -inset-6 -z-10 rounded-[2.5rem] bg-[radial-gradient(circle_at_50%_40%,rgba(168,230,207,0.55),transparent_70%)] blur-xl" />
                <div className="group relative rounded-2xl bg-white p-2 shadow-[0_22px_60px_rgba(31,41,55,0.22)] transition-transform duration-300 lg:hover:-translate-y-1 lg:hover:rotate-[-1deg]">
                  <div className="absolute left-2 top-2 z-10 h-[calc(100%-1rem)] w-5 rounded-l-2xl bg-[linear-gradient(to_right,rgba(0,0,0,0.12),rgba(0,0,0,0.02))]" />
                  <img
                    src={cover}
                    alt="Portada del ebook El Arca de Noé con arcoíris, animales y paloma para colorear"
                    className="h-auto w-full rounded-xl"
                    width="720"
                    height="960"
                    loading="eager"
                  />
                </div>
                <div className="absolute -bottom-4 left-1/2 h-6 w-3/4 -translate-x-1/2 rounded-[50%] bg-black/10 blur-md" />
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
